import { VEHICLE_WEIGHT_CLASSES } from "@/shared/constants/offer-cargo";
import type { LoadableData } from "@/shared/lib/loadable";
import { safeParseInt } from "@/shared/lib/number";
import { BaseTable } from "@/shared/ui/base-table";
import type { Column } from "@/shared/ui/base-table/types";
import { Typography } from "@mui/material";
import type React from "react";
import type {
  MasterDataVehicle,
  MasterDataVehicleListPageProps,
} from "../../model";

type VehicleTableData = MasterDataVehicle;
export type VehicleTableProps = {
  vehicles: LoadableData<MasterDataVehicleListPageProps["vehicles"]>;
  onVehicleClick: (vehicleId: number) => void;
};
export const VehicleTable: React.FC<VehicleTableProps> = (props) => {
  const data: VehicleTableData[] = props.vehicles.data;
  const columns: Column<VehicleTableData>[] = [
    {
      key: "number",
      label: "車両ナンバー",
      sortable: true,
      filterable: true,
      cell: (row) => {
        return <Typography fontWeight={700}>{row.number}</Typography>;
      },
    },
    {
      key: "name",
      label: "車名",
      sortable: true,
      filterable: true,
      cell: (row) => {
        return <Typography>{row.name ?? "-"}</Typography>;
      },
    },
    {
      key: "weightClass",
      label: "トン数(車格)",
      sortable: true,
      cell: (row) => {
        // workaround: GET vehiclesはweightClassを文字列として返しますが、VEHICLE_WEIGHT_CLASSES.valueは数値です
        const parsedWeightClass = safeParseInt(row.weightClass);
        const weightClassLabel = VEHICLE_WEIGHT_CLASSES.find(
          (weightClass) => weightClass.value === parsedWeightClass,
        )?.label;
        return <Typography>{weightClassLabel ?? "-"}</Typography>;
      },
    },
    {
      key: "shapeText",
      label: "ボディタイプ(車体の形状)",
      sortable: true,
      cell: (row) => {
        return <Typography>{row.shapeText}</Typography>;
      },
    },
    {
      key: "memo",
      label: "その他・特記事項",
      cell: (row) => {
        return <Typography sx={{ maxWidth: 480 }}>{row.memo}</Typography>;
      },
    },
  ];

  return (
    <BaseTable
      rows={data}
      columns={columns}
      onRowClick={(row) => props.onVehicleClick(row.id)}
      noDataMessage="車両が登録されていません。"
    />
  );
};
